export default "__VITE_ASSET__8eHGZYZH__"